import styled from 'styled-components';

export const LoadingViewWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 50%;
  justify-content: center;
  align-items: center;
`;
